import { render, staticRenderFns } from "./message-customer-service.vue?vue&type=template&id=67281333&scoped=true"
import script from "./message-customer-service.vue?vue&type=script&lang=ts"
export * from "./message-customer-service.vue?vue&type=script&lang=ts"
import style0 from "./message-customer-service.vue?vue&type=style&index=0&id=67281333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67281333",
  null
  
)

export default component.exports